export const parseJsonSafely = (value: any): any => {
    if (!value) return null;
    if (typeof value === 'object') return value;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
};
